export type GlobalAppSlug =
  | "home"
  | "crm"
  | "finance"
  | "human-resources"
  | "marketing"
  | "knowledge"
  | "projects"
  | "worksuite"
  | "pay"
  | "analytics"
  | "custom-apps"
  | "support"
  | "platform";

export const DASHBOARD_APP_ORDER: GlobalAppSlug[] = [
  "home",
  "crm",
  "finance",
  "human-resources",
  "marketing",
  "knowledge",
  "projects",
  "worksuite",
  "pay",
  "analytics",
  "custom-apps",
  "support",
  "platform",
];

export const DASHBOARD_ENTITLEMENT_SLUGS: Exclude<GlobalAppSlug, "home">[] = DASHBOARD_APP_ORDER.filter(
  (s): s is Exclude<GlobalAppSlug, "home"> => s !== "home",
);

const LABELS: Record<GlobalAppSlug, string> = {
  home: "Home",
  crm: "CRM",
  finance: "Finance",
  "human-resources": "Human resources",
  marketing: "Marketing",
  knowledge: "Knowledge",
  projects: "Projects",
  worksuite: "WorkSuite",
  pay: "Pay",
  analytics: "Analytics",
  "custom-apps": "Custom apps",
  support: "Support",
  platform: "Platform",
};

export const DASHBOARD_APP_BY_SLUG: Record<
  GlobalAppSlug,
  { slug: GlobalAppSlug; label: string; topNavHref: string }
> = Object.fromEntries(
  DASHBOARD_APP_ORDER.map((slug) => [
    slug,
    { slug, label: LABELS[slug], topNavHref: slug === "home" ? "/" : `/${slug}` },
  ]),
) as Record<GlobalAppSlug, { slug: GlobalAppSlug; label: string; topNavHref: string }>;
